import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { localeData } from './i18n/locale';
import configureStore from './store/configureStore';

import App from './containers/App';
import './assets/scss/base.scss';

const store = configureStore();

const app = (
  <IntlProvider locale={localeData.locale} messages={localeData.localeMessages}>
    <Provider store={store}>
      <App />
    </Provider>
  </IntlProvider>
);

ReactDOM.render(app, document.getElementById('asure-react-app'));



// WEBPACK FOOTER //
// ./src/index.jsx